import React, { useEffect } from 'react'
import { DemoNewRequestScreenProps, ROUTES } from 'app/routes/types'

const DemoNewRequest = ({ navigation }: DemoNewRequestScreenProps) => {
  useEffect(() => {
    navigation.replace(ROUTES.DEMO_PRODUCT_SELECTION)
  }, [navigation])

  return null
}

export default DemoNewRequest
